import { types } from '../types/types';

const initialState = {
    contacts: [],
    loading: false,
    count: 0,
    agents: [],
    filters: {
        id_agent: null,
        date_from: null,
        date_to: null,
        agent_filter_type: 'all'
    }
};

export const contactsAdvancedReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.contactFetchContacts:
            return {
                ...state,
                contacts: action.payload.contacts,
                loading: action.payload.loading,
                count: action.payload.count
            };

        case types.contactLoading:
            return {
                ...state,
                loading: action.payload
            };

        case 'SET_AGENTS_FOR_FILTER':
            return {
                ...state,
                agents: action.payload
            };

        case 'SET_ADVANCED_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        case 'CLEAR_ADVANCED_FILTERS':
            return {
                ...state,
                filters: initialState.filters
            };

        case types.contactCleanList:
            return {
                ...state,
                contacts: [],
                count: 0
            };

        case 'UPDATE_CONTACT_ADVANCED':
            return {
                ...state,
                contacts: state.contacts.map(contact =>
                    contact._id === action.payload._id
                        ? { ...contact, ...action.payload }
                        : contact
                )
            };

        default:
            return state;
    }
};
